import React from "react";
import Typography from "../../Utility/Typography";
import "./SegmentedTabs.css";

const SegmentedTabs = ({ tabs = [], activeTab, onChange }) => {
  return (
    <div className="flex flex-wrap -mx-4 mt-0 mb-4">
      <div className="w-full bg-surface-primary p-4">
        <div className="project-settings-segmented-control inline-flex flex-wrap items-center gap-2 p-1 rounded-lg border border-border-primary">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;

            return (
              <button
                key={tab.id}
                type="button"
                className={`project-settings-segment-btn flex items-center gap-2 px-3 py-1.5 text-xs font-medium rounded-md transition-all duration-200 ease-in-out whitespace-nowrap ${
                  isActive
                    ? "bg-primary text-text-primary shadow-sm ring-2 ring-primary"
                    : "text-text-secondary hover:text-text-primary hover:bg-surface-secondary"
                }`}
                onClick={() => onChange(tab.id)}
              >
                <Typography variant="text2" component="span" className="mb-0">
                  {tab.label}
                </Typography>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SegmentedTabs;
